import { useTheme } from '@/contexts/ThemeContext';
import { DEFAULT_BACKDROP_OVERLAY } from '@/theme/themes';

/** Single fixed background layer for the active theme (Home / Program only). */
export function ThemeBackdrop() {
  const { activeTheme } = useTheme();
  if (!activeTheme?.background) return null;
  const overlay = activeTheme.overlay || DEFAULT_BACKDROP_OVERLAY;
  return (
    <div
      className="theme-backdrop"
      aria-hidden="true"
      data-testid="theme-backdrop"
      style={{ backgroundImage: `${overlay}, url(${activeTheme.background})` }}
    />
  );
}
